import { useEffect } from 'react';

const usePageTitle = (title: string) => {
  useEffect(() => {
    document.title = title ? `${title} — Wedding CC` : 'Wedding CC';
  }, [title]);
};

export default usePageTitle;
